import { render, staticRenderFns } from "./CCSizeUpIcon.vue?vue&type=template&id=476f2c39&"
import script from "./CCSizeUpIcon.vue?vue&type=script&lang=js&"
export * from "./CCSizeUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports